export default [{
	titulo: 'Casa do Trabalhador',
	icone: 'menu-icon fa fa-caret-right',
	url: '/site/casa-trabalhador',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]
